import { getActionHandler, getInitialState } from "../helpers/crudReducers";

const initialState = getInitialState("REPORT_FIELDS");
const CRUD_ACTION_HANDLERS = getActionHandler("REPORT_FIELDS");

export default function tamaracReportFields(state = initialState, action) {
  const handler = CRUD_ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
